import { render, staticRenderFns } from "./BankFailures.vue?vue&type=template&id=1cbe1107&scoped=true"
import script from "./BankFailures.vue?vue&type=script&lang=js"
export * from "./BankFailures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe1107",
  null
  
)

export default component.exports